import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56af349c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full mt-10 bg-background-medium flex flex-col items-center" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "w-full grid grid-cols-2 items-center place-items-end pr-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col sm:flex-row gap-4 max-w-s items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "eu-logo",
    src: "/EU+ERDF.png"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "uia-logo",
    src: "/Logo_UIA_couleur.png"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "flanders-logo",
    src: "/Flanders.png"
  })
], -1))
const _hoisted_5 = { class: "ml-4" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-row w-full justify-center gap-8 mt-4 mb-8"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "m-2 md:m-5 w-full flex flex-col md:flex-row items-center justify-center"
}
const _hoisted_9 = {
  href: "https://stad.gent/nl/gebruiksvoorwaarden-website-stad-gent",
  target: "_blank",
  class: "underline font-light"
}
const _hoisted_10 = {
  href: "https://static1.squarespace.com/static/5fb4f5b0509a072b93557287/t/6141f82d6a4c7d11931fd043/1631713326053/CoGhent+Privacy+Policy.pdf",
  target: "_blank",
  class: "underline md:ml-4 font-light"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_CardComponent = _resolveComponent("CardComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CardComponent, {
        large: true,
        class: "w-full"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.t('footer.eu-info')), 1)
          ]),
          (!_ctx.route.query.touch)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allSocials, (social) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: social.icon,
                    class: "p-4 cursor-pointer",
                    onClick: ($event: any) => (_ctx.toSocial(social))
                  }, [
                    _createVNode(_component_base_icon, {
                      icon: social.icon,
                      class: "black"
                    }, null, 8, ["icon"])
                  ], 8, _hoisted_7))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.route.query.touch)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                _createElementVNode("li", null, [
                  _createElementVNode("a", _hoisted_9, _toDisplayString(_ctx.t('footer.user-agreement')), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("p", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openMinimalConsentManager && _ctx.openMinimalConsentManager(...args))),
                    class: "underline md:ml-4 font-light cursor-pointer"
                  }, _toDisplayString(_ctx.t('footer.cookie-policy')), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", _hoisted_10, _toDisplayString(_ctx.t('footer.privacy-policy')), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}